import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5884006e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "achievement-detail-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "rules" }
const _hoisted_5 = { class: "stats" }
const _hoisted_6 = {
  key: 0,
  class: "month"
}
const _hoisted_7 = { class: "number" }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = { class: "all" }
const _hoisted_10 = { class: "number" }
const _hoisted_11 = { class: "subtitle" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, null, -1))
const _hoisted_13 = { class: "tokens" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_AchievementToken = _resolveComponent("AchievementToken")!
  const _component_AchievementSplash = _resolveComponent("AchievementSplash")!
  const _component_ScorecardSubpage = _resolveComponent("ScorecardSubpage")!

  return (_ctx.scorecard)
    ? (_openBlock(), _createBlock(_component_ScorecardSubpage, {
        key: 0,
        slide: _ctx.slideName,
        black: false,
        "badge-id": _ctx.total < 1 ? 'unknown-badge' : _ctx.badgeId,
        title: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Typography, { variant: "h4" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.achievementLabel), 1)
                  ], undefined, true),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Typography, { variant: "body2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.rules), 1)
                  ], undefined, true),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.value === 'allfiredup')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_Typography, { variant: "h2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.totalCalendarMonth), 1)
                          ], undefined, true),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Typography, { variant: "caption" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.month) + " Total", 1)
                          ], undefined, true),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Typography, { variant: "h2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.total), 1)
                      ], undefined, true),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Typography, { variant: "caption" }, {
                      default: _withCtx(() => [
                        _createTextVNode("All Time Total")
                      ], undefined, true),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token, i) => {
                  return (_openBlock(), _createBlock(_component_AchievementToken, {
                    key: `${i}-${token.title}-${token.description}`,
                    type: _ctx.value,
                    title: token.title,
                    description: token.description,
                    "data-id": 'pendo-achievement-drilldown',
                    onClick: _ctx.onClickToken
                  }, null, 8, ["type", "title", "description", "onClick"]))
                }), 128))
              ])
            ]),
            (_ctx.showSplash)
              ? (_openBlock(), _createBlock(_component_AchievementSplash, {
                  key: 0,
                  type: _ctx.value,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSplash = false))
                }, null, 8, ["type"]))
              : _createCommentVNode("", true)
          ])
        ], undefined, true),
        _: 1
      }, 8, ["slide", "badge-id"]))
    : _createCommentVNode("", true)
}